const config = require("../config")

module.exports = {
    //农资注册接口
    register: {
        url: config.base_dev_url + "z_agricultural_store/register",
        type: "post",
    },
    getSessionStore: {
        url: config.base_dev_url + "mini_session_store/get/{key}",
        type: "get",
    },
    saveSessionStore: {
        url: config.base_dev_url + "mini_session_store/save",
        type: "post",
    },
    //查询当前农资店的成员列表
    listManagerList: {
        url: config.base_dev_url + "z_agricultural_store_manager/list",
        type: "get",
    },
    //获取权限列表
    listPermissionList: {
        url: config.base_dev_url + "z_agricultural_store_manager/permissionList",
        type: "get",
    },
    //保存成员信息（新增或更新）
    saveManager: {
        url: config.base_dev_url + "z_agricultural_store_manager/save",
        type: "post",
    },
    //获取职责列表
    listDutyList: {
        url: config.base_dev_url + "z_agricultural_store_manager/dutyList",
        type: "get",
    },
    //删除成员
    deleteManager: {
        url: config.base_dev_url + "z_agricultural_store_manager/delete",
        type: "get",
    },
    //批量更新成员角色
    batchSaveManager: {
        url: config.base_dev_url + "z_agricultural_store_manager/batchUpdateRole",
        type: "post",
    },
    //邀请成员加入农资店
    inviteManager: {
        url: config.base_dev_url + "z_agricultural_store_manager/invite",
        type: "post",
    },
    //查询简单农事记录列表
    getSimpleList: {
        url: config.base_dev_url + "z_farm_work_record/getSimpleList",
        type: "get",
    },
    //通知列表
    listNotice: {
        url: config.base_dev_url + "mini_notification/page/{page}/{limit}",
        type: "get",
    },
    //确认卡片的确认接口
    confirmCard: {
        url: config.base_dev_url + "mini_notification/confirm",
        type: "get",
    },
    //查询新的通知组
    noticeGroupList: {
        url: config.base_dev_url + "mini_notification/groupList",
        type: "get",
    },
}